import React from "react";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import ExtensionIcon from '@material-ui/icons/Extension';
import TimelineIcon from '@material-ui/icons/Timeline';
import CachedIcon from '@material-ui/icons/Cached';

// ICONOS MENU
import { Hidden } from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import CrearBeca from "@material-ui/icons/Edit";
import SettingsIcon from "@material-ui/icons/Settings";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import GroupIcon from "@material-ui/icons/Group";
import Instructivo from '@material-ui/icons/LocalLibrary';

const clase = (item, selec, tipo = "") =>
  item === selec ? `item_selec${tipo}` : `item_modulo`;

export function Menu({ sele, seleccionar, estudiante, administrador, newSol = true }) {
  const pintar = (app, claseN = "") => {
    return (
      <div className={claseN}>
        <BottomNavigation
          showLabels
          className={clase("miproceso", sele)}
          onClick={() => seleccionar("miproceso")}
        >
          <BottomNavigationAction
            label={"Procesos"}
            icon={<LocationOnIcon />}
          />
        </BottomNavigation>

        {
          newSol && !estudiante && 
          <BottomNavigation
            showLabels
            className={clase("nuevo", sele)}
            onClick={() => seleccionar("nuevo")}
          >
            <BottomNavigationAction label={"Nuevo"} icon={<CrearBeca />} />
          </BottomNavigation>
        }
      </div>
    );
  };

  return (
    <div>
      <div>
        <Hidden xsDown> {pintar(false, "menu_modulo")} </Hidden>
        <Hidden smUp> {pintar(true, "menu_modulo_app")}</Hidden>
      </div>
    </div>
  );
}

export function SisefMenu({ sele, seleccionar, estudiante, instructivo }) {
  const pintar = (app, claseN = "") => {
    return (
      <div className={claseN}>
        <BottomNavigation
          showLabels
          className={clase("miproceso_ini", sele)}
          onClick={() => seleccionar("miproceso_ini")}
        >
          <BottomNavigationAction
            label={"Procesos"}
            icon={<LocationOnIcon />}
          />
        </BottomNavigation>

        {
          !estudiante &&
          <BottomNavigation
            showLabels
            className={clase("administrar", sele)}
            onClick={() => seleccionar("administrar")}
          >
            <BottomNavigationAction
              label={"Administrar"}
              icon={<SettingsIcon />}
            />
          </BottomNavigation>
        }
        <BottomNavigation
          showLabels
          className={clase("Instructivo", sele)}
          onClick={() => window.open(instructivo, '_blank')}
        >
          <BottomNavigationAction
            label={"Instructivo"}
            icon={<Instructivo />}
          />
        </BottomNavigation>
        {/* {
          !estudiante &&
          <BottomNavigation
            showLabels
            className={clase("vista_estudiante", sele)}
            onClick={() => seleccionar("vista_estudiante")}
          >
            <BottomNavigationAction
              label={"Vista Estudiante"}
              icon={<SettingsIcon />}
            />
          </BottomNavigation>
        } */}


      </div>
    );
  };

  return (
    <div>
      <div>
        <Hidden xsDown> {pintar(false, "menu_modulo")} </Hidden>
        <Hidden smUp> {pintar(true, "menu_modulo_app")}</Hidden>
      </div>
    </div>
  );
}

export function SeguimientoMenu({ sele = 0, seleccionar = () => { } }) {
  const pintar = (claseN = "") => {
    return (
      <div className={claseN}>
        <BottomNavigation showLabels>
          <BottomNavigationAction
            label={"Detalle"}
            icon={<ImportContactsIcon />}
            className={clase("detalle", sele)}
            onClick={() => seleccionar("detalle")}
          />
          <BottomNavigationAction
            label={"Profesores"}
            icon={<GroupIcon />}
            className={clase("docentes", sele)}
            onClick={() => seleccionar("docentes")}
          />
          <BottomNavigationAction
            label={"Historial"}
            icon={<TimelineIcon />}
            className={clase("historial", sele)}
            onClick={() => seleccionar("historial")}
          />
          <BottomNavigationAction
            label={"Estados"}
            icon={<CachedIcon />}
            className={clase("estados", sele)}
            onClick={() => seleccionar("estados")}
          />
          <BottomNavigationAction
            label={"Versiones"}
            icon={<ExtensionIcon />}
            className={clase("versiones", sele)}
            onClick={() => seleccionar("versiones")}
          />
        </BottomNavigation>
      </div>
    );
  };

  return <div>{pintar("menu_modal")}</div>;
}